import GameScene from "../../../scenes/GameScene";
import Actor from "../Actor";

export default class Item extends Actor {
    /**
     * @param {string} id
     * @param {PIXI.Texture} texture
     */
    constructor(id, texture) {
        super(id);

        this._texture = texture;

        this._tween = null;

        this._consumable = false;

        this.interactable = true;
        this.collisionEnabled = false;

        this.signals.spawn = new P3.utils.MiniSignal();
        this.signals.collect = new P3.utils.MiniSignal();
    }

    init() {
        super.init();

        this.addViewWithTexture(this._texture);

        this.enabled = false;
    }

    onViewAdded() {
        this._view.anchor.set(0.5, 1);

        this.animateIn().then(() => this.animateFloat());
    }

    destroy() {
        this.stopAnimations();

        super.destroy();
    }

    spawn() {
        this.enabled = true;

        this.signals.spawn.dispatch(this);
    }

    collect() {
        this.onInteractionRangeExit();

        this.enabled = false;

        this.signals.collect.dispatch(this);
        
        return true;
    }

    /**
     * @return {Promise}
     */
    animateIn() {
        return new Promise((resolve) => {
            this.stopAnimations();

            this._tween = gsap.timeline({ onComplete: resolve })
            GameScene.active.addTween(this._tween);

            this._tween.add(gsap.to(this._view, 0.2, {
                y: -30,
                ease: Power1.easeOut,
                repeat: 1,
                yoyo: true
            }), 0);

            this._view.scale.set(0);
            this._tween.add(gsap.to(this._view.scale, 0.24, {
                x: 1,
                y: 1,
                ease: "back.out(2.4)"
            }), 0);

            if (this._shadow) {
                this._shadow.alpha = 0;
                this._tween.add(gsap.to(this._shadow, 0.24, {
                    alpha: 1,
                    ease: Power1.easeInOut
                }), 0);
            }
        });
    }

    animateFloat() {
        this.stopAnimations();

        this._tween = GameScene.active.addTween(gsap.to(this._view, 1, {
            y: -10,
            ease: Power1.easeInOut,
            repeat: -1,
            yoyo: true
        }));
    }

    stopAnimations() {
        if (this._tween) {
            GameScene.active.removeTween(this._tween, true);
            this._tween = null;
        }
    }

    /**
     * @returns {string}
     */
    get id() {
        return this._id;
    }

    /**
     * @return {PIXI.Texture}
     */
    get texture() {
        return this._texture;
    }

    /**
     * @return {boolean}
     */
    get consumable() {
        return this._consumable;
    }

    /**
     * @return {boolean}
     */
    get isSpawned() {
        return this._enabled;
    }
}